import React from 'react';
import { Box, Typography } from '@mui/material';

export default function NotFoundPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        textAlign: 'center',
        bgcolor: 'background.default',
        color: 'text.primary',
        px: 2,
      }}
    >
      <Typography variant="h1" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom>
        Ups! Die Seite, die Sie suchen, existiert nicht.
      </Typography>
      <Typography variant="body1" gutterBottom>
        Sie wurde vielleicht entfernt, umbenannt oder hat nie existiert.
      </Typography>
    </Box>
  );
}
